var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shop-edit',
  created () {
    const loadData = async function(self) {
      self.loading = true 
      await self.getAreas()
      await self.search()
      self.loading = false 
    }
    loadData(this)
  },
  data () {
    return {
      canValidate: true,
      keepAddress: null,
      shop: {
        shop_name: null,
        shop_name_furigana: null,
        shop_post_no: null,
        shop_address: null,
        shop_tel: null,
        shop_fax: null,
        map_lat: null,
        map_lng: null,
        map_zoom: 15,
        area: null
      },
      map: null,
      mk: null,
      areaWork: null,
      loading: false
    }
  },
  computed: {
    areas () {
      return this.$store.getters.areas
    },
    selectArea: function() {
      this.shop.area = this.areaWork
    },
    required: function () {
      return {
        shop_post_no: utils.isBlank(this.shop.shop_post_no),
        shop_address: utils.isBlank(this.shop.shop_address),
        post_no_format: !utils.isPostNo(this.shop.shop_post_no)
      }
    },
    validation: function() {
      var hiragana = /^[\u3040-\u309fー]+$/
      var tel = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
      var fax = /^[0-9-]+$/
      var number = /^[0-9]+$/
      var v = {
        shop_name: !!this.shop.shop_name,
        shop_name_furigana: hiragana.test(this.shop.shop_name_furigana),
        shop_post_no: !!this.shop.shop_post_no,
        shop_address: !!this.shop.shop_address,
        shop_tel: tel.test(this.shop.shop_tel),
        shop_fax: fax.test(this.shop.shop_fax) || !this.shop.shop_fax,
        not_input: !!this.shop.shop_name &&
                   hiragana.test(this.shop.shop_name_furigana) &&
                   !!this.shop.shop_post_no &&
                   number.test(this.shop.shop_post_no) &&
                   !!this.shop.shop_address &&
                   tel.test(this.shop.shop_tel) &&
                   (fax.test(this.shop.shop_fax) || !this.shop.shop_fax)
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    shopEditDetail: function () {
      return this.$store.getters.shopEditDetail
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    notify () {
      return this.$store.getters.shopEditNotify
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getAreas () {
      await this.$store.dispatch('AREA_ALL_GET', {})
    },
    selectedArea () {
      this.shop.area = this.areaWork
    },
    goUserLists: function () {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    onClickCancel: function () {
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    search: async function() {
      var data = {}
      var self = this
      var callback = function () {
        self.shop.shop_name = self.shopEditDetail.attributes['shop-name']
        self.shop.shop_name_furigana = self.shopEditDetail.attributes['shop-name-furigana']
        self.shop.shop_post_no = self.shopEditDetail.attributes['shop-post-no']
        self.shop.shop_address = self.shopEditDetail.attributes['shop-address']
        self.shop.shop_tel = self.shopEditDetail.attributes['shop-tel']
        self.shop.shop_fax = self.shopEditDetail.attributes['shop-fax']
        self.shop.map_lat = self.shopEditDetail.attributes['shop-map-lat']
        self.shop.map_lng = self.shopEditDetail.attributes['shop-map-lng']
        self.shop.map_zoom = self.shopEditDetail.attributes['shop-map-zoom']
        self.shop.area = self.shopEditDetail.attributes['area']
        setTimeout(() => {
          self.initMap()
        }, 100)
      }
      this.$store.dispatch('SHOP_EDIT', { id: this.$route.params.id, data: data, callback: callback })
    },
    onBlurAddress: function () {
      if ((this.shop.shop_address !== null) && (this.shop.shop_address !== "")) {
        if (this.keepAddress !== this.shop.shop_address) {
          this.keepAddress = this.shop.shop_address
          this.searchLocationByGeocoder()
        }
      }
    },
    onClickSave: function () {
      var self = this
      var data = {}
      data = self.shop
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        this.$store.dispatch('SHOP_UPDATE', { data: data, callback: self.onSaved, shop_id: self.$route.params.id })
      }else{
        console.log("need edit")
      }
    },
    onSaved: function (result) {
      this.$router.push('/shops/' + this.$route.params.id)
    },
    /** 郵便番号入力補助 */
    onChangePostNo: function () {
      if (this.shop.shop_post_no) {
        this.shop.shop_post_no = this.shop.shop_post_no.replace(/-/g,"")
      }

      if (!!this.shop.shop_post_no && utils.regex.post_no.test(this.shop.shop_post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.shop.shop_post_no, callback: (addr) => {
            if (addr) {
              this.shop.shop_address = addr.address1 + addr.address2
              this.onChangeAddress()
              this.onBlurAddress()
            }
          }
        })
      }
    },
    /** 住所変更時イベント */
    onChangeAddress: function () {
      this.half()
      var arr = []
      if (utils.isPresent(this.shop.shop_post_no)) arr.push(this.shop.shop_post_no)
      if (utils.isPresent(this.shop.shop_address)) arr.push(this.shop.shop_address)
      if (arr.length > 0) {
        var address = arr.join(' ')
        if (window.googleMapsQuerySearch) {
          window.googleMapsQuerySearch(address)
        }
      }
    },
    initMap: function () {
      var self = this
      var mapDiv = document.getElementById('map')
      var latlng = new google.maps.LatLng(self.shop.map_lat, self.shop.map_lng)
      self.map = new google.maps.Map(mapDiv, {
        zoom: self.shop.map_zoom,
        center: latlng
      })

      self.mk = new google.maps.Marker({
        position: latlng
      })
      self.mk.setMap(self.map);

      google.maps.event.addListener(self.map, 'click', self.setMarker)
    },
    setMarker: function (event) {
      this.shop.map_lat = event.latLng.lat()
      this.shop.map_lng = event.latLng.lng()
      this.shop.map_zoom = this.map.getZoom()
      var latlng = new google.maps.LatLng(event.latLng.lat(),event.latLng.lng())
      if(this.mk){
        this.mk.setPosition(latlng)
      }else{
        this.mk = new google.maps.Marker({
          map: this.map,
          position: latlng,
        })
        this.mk.setMap(this.map)
      }
    },
    half: function () {
      if (!utils.isBlank(this.shop.shop_name)) this.shop.shop_name = utils.emHalf(this.shop.shop_name)
      if (!utils.isBlank(this.shop.shop_name_furigana)) this.shop.shop_name_furigana = utils.emHalf(this.shop.shop_name_furigana)
      if (!utils.isBlank(this.shop.shop_address)) this.shop.shop_address = utils.emHalf(this.shop.shop_address)
    },
    searchLocationByGeocoder: function(){
      var self = this
      var geocoder = new google.maps.Geocoder()
      geocoder.geocode({'address': self.shop.shop_address}, function(results, status){
        if(status == google.maps.GeocoderStatus.OK){
          self.shop.map_lat = results[0].geometry.location.lat()
          self.shop.map_lng = results[0].geometry.location.lng()
          self.shop.map_zoom = 15
        }
      })
      setTimeout(() => {
        self.initMap()
      }, 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-edit.js